import axios from "axios";
import { createQueryStringFromObject } from "../../Helpers/queryStringCreator";

export const pullAllUsers = (requestBody, clientId) => {
  var queryString = createQueryStringFromObject(requestBody);
  if (clientId !== undefined) {
    queryString += (queryString ? "&" : "?") + "clientId=" + clientId;
  }
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/usermanagement/listAll" + queryString)
    .then((res) => res.data);
};

export const getRoleTitles = () => {
  return axios.get(import.meta.env.VITE_BACKEND_API + "/api/usermanagement/roleTitles/").then((res) => res.data);
};

export const getUserRoles = (userId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/usermanagement/userRoles/" + userId)
    .then((res) => res.data);
};

export const editPermissions = (userId, roleId, clientId, roleRights, crmRole) => {
  var roleIdQueryParam = "";
  // roleId will be undefined any time a user is being assigned a CRM Role for a
  // Base Client that does not have Careers enabled
  if (roleId !== undefined) {
    roleIdQueryParam = "&roleId=" + roleId;
  }
  return axios
    .put(
      import.meta.env.VITE_BACKEND_API +
        "/api/usermanagement/editPermissions?userId=" +
        userId +
        roleIdQueryParam +
        "&clientId=" +
        clientId +
        "&roleRights=" +
        roleRights +
        "&crmRole=" +
        crmRole
    )
    .then((res) => {
      return true;
    })
    .catch((error) => {
      return false;
    });
};
